// SPDX-License-Identifier: LicenseRef-Proprietary

type Key = 'htaDemo.pins' | 'htaDemo.comments' | 'htaDemo.activity' | 'htaDemo.programme' | 'htaDemo.controls' | 'htaDemo.krar' | 'htaDemo.meta' | 'htaDemo.tree';

export function getItem<T = unknown>(key: Key, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function setItem<T = unknown>(key: Key, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota errors in demo
  }
}

export function logActivity(message: string): void {
  try {
    const list = getItem<any[]>('htaDemo.activity', []);
    const entry = { ts: Date.now(), msg: message };
    const next = [...list, entry].slice(-50);
    setItem('htaDemo.activity', next);
  } catch {
    // ignore
  }
}

export function cleanupActivityLogs(): void {
  try {
    const list = getItem<any[]>('htaDemo.activity', []);
    // Filter out any entries that contain "Salo" or "PCV" references
    const cleaned = list.filter(entry => 
      !entry.msg?.toLowerCase().includes('salo') && 
      !entry.msg?.toLowerCase().includes('pcv')
    );
    if (cleaned.length !== list.length) {
      setItem('htaDemo.activity', cleaned);
    }
  } catch {
    // ignore
  }
}

// Run cleanup immediately when module loads to clean up any existing entries
cleanupActivityLogs();


